import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
export default function DataTableSkeleton() {
  return (
    <Box height="100%">
      <Stack direction="column" spacing={2} padding={2} height="100%">
        <Skeleton variant="rectangular" height="4em" />
        {[...Array(10).keys()].map((i) => (
          <Skeleton key={`skeleton-row-${i}`} variant="rectangular" />
        ))}
        <Skeleton variant="rectangular" height="4em" />
      </Stack>
    </Box>
  );
}
